const SettingsTypes = {
  GET_TMS_SETTINGS_PROGRESS: 'SETTINGS_TYPES.GET_TMS_SETTINGS_PROGRESS',
  GET_TMS_SETTINGS_SUCCESS: 'SETTINGS_TYPES.GET_TMS_SETTINGS_SUCCESS',
  GET_TMS_SETTINGS_ERROR: 'SETTINGS_TYPES.GET_TMS_SETTINGS_ERROR',
  SAVE_TMS_SETTINGS_PROGRESS: 'SETTINGS_TYPES.SAVE_TMS_SETTINGS_PROGRESS',
  SAVE_TMS_SETTINGS_SUCCESS: 'SETTINGS_TYPES.SAVE_TMS_SETTINGS_SUCCESS',
  SAVE_TMS_SETTINGS_ERROR: 'SETTINGS_TYPES.SAVE_TMS_SETTINGS_ERROR',

  DELETE_TMS_SETTINGS_SHIPMENT_RESTRICTION: 'SETTINGS_TYPES.DELETE_TMS_SETTINGS_SHIPMENT_RESTRICTION',

  GET_USER_THEMES_PROGRESS: 'SETTINGS_TYPES.GET_USER_THEMES_PROGRESS',
  GET_USER_THEMES_SUCCESS: 'SETTINGS_TYPES.GET_USER_THEMES_SUCCESS',
  GET_USER_THEMES_ERROR: 'SETTINGS_TYPES.GET_USER_THEMES_ERROR',
  SET_USER_THEMES: 'SETTINGS_TYPES.SET_USER_THEMES',
};

export default SettingsTypes;
